import { stringifyUrlQuery } from 'helpers';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type {
  GetOrganisationTemplatesRequestType,
  GetOrganisationTemplatesResponseType,
} from '../types';

export const getOrganisationTemplates = async ({
  pathParams: { organisationId },
  queryParams: { name, page, perPage },
}: GetOrganisationTemplatesRequestType) => {
  const query = stringifyUrlQuery({
    name,
    page,
    perPage,
  });

  const url = `/api/v2/organisations/${organisationId}/templates${query}`;

  const { data } =
    await apiAuthClient.get<GetOrganisationTemplatesResponseType>(url);

  return data;
};
